import { Node } from '@tiptap/core'
import { ReactNodeViewRenderer } from '@tiptap/react'
import { Plugin, PluginKey } from '@tiptap/pm/state'
import CarouselComponent from './CarouselComponent'

const ImageCarousel = Node.create({
  name: 'imageCarousel',

  group: 'block',

  atom: true,

  addAttributes() {
    return {
      images: {
        default: [],
        // Array of { src: string, alt: string }
      },
    }
  },
  
  addOptions() {
    return {
      upload: undefined
    }
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-type="image-carousel"]',
      },
    ]
  },

  renderHTML({ node }) {
    const images = node.attrs.images || []

    // Simple HTML for serialization/storage
    return [
      'div',
      {
        'data-type': 'image-carousel',
        class: 'image-carousel'
      },
      ...images.map(img =>
        img.isUploadedImage
          ? ['div', { class: 'uploading' }, 'Loading...']
          : ['img', { src: img.src, alt: img.alt || '' }]
      )
    ]
  },

  addNodeView() {
    return ReactNodeViewRenderer(CarouselComponent)
  },

  addCommands() {
    return {
      insertCarousel: (images = []) => ({ commands }) => {
        return commands.insertContent({
          type: this.name,
          attrs: { images },
        })
      },
    }
  },

  addProseMirrorPlugins() {
    
    const uploadFunction = this.options.upload
    const editor = this.editor;
    
    return [
      new Plugin({
        key: new PluginKey('imageCarouselUpload'),

        props: {
        },
      }),
    ]
  },
})

export default ImageCarousel